import React from "react";

const aloki_upadhyay = () => {
  return (
    <div>
      <h1>Aloki Upadhyay</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        It consisted of 2 rounds:
      </p>

      <ol>
        <li>Aptitude round(online test from college) : 29th September 2025 </li>
        <li>Interviews(in person) : 30th September 2025</li>
      </ol>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        Interviews for three distinct roles were held on September 30th, 2025,
        the day after the aptitude round on September 29th. Each role had its
        own interview structure:
        <br />
        LCS: 2 Technical + 1 HR
        <br />
        MENDIX: 1 Technical + 1 (Technical + HR)
        <br />
        DM: 1 Technical
        <br />
        Candidates were not given a choice of role; instead, we were sorted into
        various positions on the interview day.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round lasted for <strong>1 hour and 20 minutes</strong> and
        consisted of <strong>24 questions</strong>.<br />
        The questions consisted of a combination of general aptitude, which
        included logical reasoning and quantitative problems, and concepts
        related to Object-Oriented Programming (OOPs).
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
      </p>

      <p>
        <strong>51 students</strong> were shortlisted after the Aptitude Round.
        They were further divided into different roles as follows:
      </p>

      <ul>
        <li>
          <p>
            <strong>LCS:</strong> 35 students
          </p>
        </li>
        <li>
          <p>
            <strong>MENDIX:</strong> 11 students
          </p>
        </li>
        <li>
          <p>
            <strong>DM:</strong> 5 students
          </p>

          <p>
            The company assigned roles directly, so students did not have the
            option to choose their preference.
          </p>
        </li>
      </ul>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The interviews were scheduled the day after the aptitude round so there
        wasn’t a lot of time before the interviews.I concentrated on thoroughly
        reviewing my projects, the technologies and data structures I used, and
        I also reviewed my entire resume to ensure that I knew my resume inside
        and out.{" "}
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        I was shortlisted for the Mendix role. It consisted of two interview
        rounds:
        <br />
        1st Round(Technical):{" "}
      </p>

      <ul>
        <li>
          I was questioned about my projects, with a specific focus on the data
          structures I implemented in them. Given that I had included a{" "}
          <strong>MERN stack</strong> project in my portfolio, the interview
          also featured questions pertaining to <strong>web development</strong>
          .{" "}
        </li>
        <li>
          I was also asked to provide <strong>pseudocode</strong> for some of
          the <strong>data structures</strong> that were mentioned in my
          project.{" "}
        </li>
        <li>
          They also presented me with a <strong>logic puzzle</strong> (the coin
          weighing puzzle).{" "}
        </li>
        <li>
          <strong>Duration</strong> : 45 mins{" "}
        </li>
        <li>
          <strong>Shortlisting</strong> : Out of <strong>11</strong> students{" "}
          <strong>4</strong> were shortlisted for the next round.
        </li>
      </ul>

      <p>2nd Round (Technical+HR):</p>

      <ul>
        <li>
          Beyond the scope of my projects, I was presented with a separate DSA
          problem and they were basically testing out what data structure I
          would use for the specific problem.{" "}
        </li>
        <li>
          The interview also incorporated a non-technical component, where I was
          asked to respond to a variety of behavioural and situational questions
          designed to assess my soft skills and decision-making processes.{" "}
        </li>
        <li>
          <strong>Duration</strong> : 50-60 mins{" "}
        </li>
        <li>
          <strong>Shortlisting</strong> : Out of <strong>4</strong> students,{" "}
          <strong>3</strong> were shortlisted.
        </li>
      </ul>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interview focused on the projects and skills written in my resume.
        They mainly asked me about :{" "}
      </p>

      <ul>
        <li>Data Structures and Algorithms - concept and pseudocode </li>
        <li>
          Web Development - MERN (project was mentioned in resume hence asked){" "}
        </li>
        <li>Logic Puzzles</li>
      </ul>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ul>
        <li>Striver’s A2Z DSA Course/Sheet </li>
        <li>GFG Puzzles</li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Maintain a daily practice routine. When working on any concept, solve a
        wide range of problems across{" "}
        <strong>different difficulty levels</strong> to confirm you've{" "}
        <strong>fully mastered</strong> it before proceeding.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        The projects I listed on my resume were the source of many questions.
        Most of the DSA questions I was asked were also based on the data
        structures I had used in those projects. In the second interview, they
        also asked about my extracurriculars to get a better sense of my
        personality and assess my behavioural and situational skills.{" "}
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Make sure that you are thorough with the projects and skills you{" "}
        <strong>list</strong> on your resume. Speak <strong>confidently</strong>
        , and remember that even if you don't know the exact solution to a
        problem, clearly{" "}
        <strong>explaining your thought process and approach</strong> is what
        they are looking for.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Focus on knowing your resume inside out. Make sure you are thorough with
        the technologies and concepts used in your project. Apart from this,
        keep practising DSA problems regularly using guiding sheets like
        Striver’s sheets and practise puzzles.
        <br />
        Do not get scared if you don't know how to answer a particular question.
        Take some time to understand the questions, confirm your interpretation
        with the interviewer and start by verbalising and thinking out loud your
        approach and thought process.
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Phone No :</strong> +91 8459206901
        <br />
        <strong>Email :</strong> <a href="mailto:aloki.upadhyay@gmail.com">aloki.upadhyay@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/aloki-upadhyay-9a317a137/"> Aloki Upadhyay</a>
      </p>

      <hr />
    </div>
  );
};

export default aloki_upadhyay;
